import React from 'react';
import useTheme from 'src/customizations/themes/hooks/useTheme';
import Row from '../../layout/Row';
import TabHeaderItem from './TabHeaderItem';
function TabHeader({ tabs, activeIndex, onChange, ...rowProps }) {
    const [{ theme }] = useTheme();
    return (React.createElement(Row, { bg: theme.palette.background.main, ...rowProps }, tabs.map((tab, index) => (React.createElement(TabHeaderItem, { key: String(tab.id), label: tab.label, count: tab.count, selected: activeIndex === index, onPress: () => onChange(index) })))));
}
export default TabHeader;
